import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiLogOut, FiAward, FiUser } from 'react-icons/fi';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    logout();
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar" style={{ display: 'none' }}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="navbar-logo-icon">
            🎓
          </div>
          SpeakPro
        </Link>

        <div className="navbar-menu">
          <Link 
            to="/" 
            className={`navbar-item ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link 
            to="/courses" 
            className={`navbar-item ${isActive('/courses') ? 'active' : ''}`}
          >
            Courses
          </Link>
          {user && (
            <Link 
              to="/dashboard" 
              className={`navbar-item ${isActive('/dashboard') ? 'active' : ''}`}
            >
              Dashboard
            </Link>
          )}
        </div>

        <div className="navbar-auth">
          {user ? (
            <>
              <div className="navbar-user">
                <Link to="/profile" className="navbar-avatar">
                  {user.username?.charAt(0).toUpperCase()}
                </Link>
                <span className="navbar-username">{user.username}</span>
                <span className="navbar-points">
                  <FiAward />
                  {user.totalPoints || 0}
                </span>
              </div>
              <button className="btn btn-ghost" onClick={handleLogout}>
                <FiLogOut />
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost">
                Login
              </Link>
              <Link to="/register" className="btn btn-primary">
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
